import styled from 'styled-components';

import {
  brandBlack,
  whiteSphera,
  neutralBlue,
  neutralBlueGray,
  supportLemonGreen,
  neutralLight,
  greenSp
} from 'src/utilities/UIStyles/variables/Colors';

export const BeneficiariesCard = styled.div`
  width: 45%;
  display: flex;
  flex-wrap: wrap;
  margin: 0 auto 2% auto;
  padding: 2.5%;
  border-radius: 5px;
  -webkit-box-shadow: 1px 1px 10px 0px rgba(0, 0, 0, 0.1);
  box-shadow: 1px 1px 10px 0px rgba(0, 0, 0, 0.1);
  > h2 {
    color: ${neutralBlueGray};
    font-size: 1.5vw;
    margin-left: 2%;
  }
  > button {
    background-color: ${neutralBlue};
    border: none;
    border-radius: 5px;
    padding: 0.5% 3%;
    margin-left: 90%;
    color: ${brandBlack};
    font-size: 1vw;
  }
  @media (min-width: 600px) and (max-width: 1024px) {
  }

  @media (max-width: 600px) {
  }
`;

export const Editables = styled.div`
  width: 100%;
  display: flex;
  justify-content: end;
  > button {
    background-color: ${neutralBlue};
    border: none;
    border-radius: 5px;
    padding: 0.5% 3%;
    margin: 0 2% 1% 2%;
    color: ${brandBlack};
    font-size: 1vw;
  }
`;

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: end;
  width: 100%;
  margin-bottom: 3%;
  > button {
    background-color: ${greenSp};
    border: none;
    border-radius: 5px;
    padding: 0.5% 3%;
    margin-left: 5%;
    color: ${brandBlack};
    font-size: 1vw;
  }
`;

export const InfoBeneficiary = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-evenly;
  margin: 3% 2.5%;
  width: 100%;
  padding-bottom: 1%;
  /* background-color: rgb(245, 245, 245); */
  border-bottom: 1px solid ${greenSp};
  > div {
    width: 30%;
    justify-content: space-evenly;
    margin-bottom: 2%;
    > h3 {
      color: ${neutralBlueGray};
      font-size: 1.2vw;
    }
    > p {
      color: ${neutralBlueGray};
      font-size: 1.2vw;
      padding: 1% 0;
    }
    > input {
      border-radius: 5px;
      width: 80%;
      border-style: none;
      border: 1px solid ${neutralBlue};
      padding: 1% 0;
    }
    > select {
      border-radius: 5px;
      border-style: none;
      width: 80%;
      padding: 1% 0;
      border: 1px solid ${neutralBlue};
    }
  }
`;

export const AddressBeneficiary = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-evenly;
  margin: 3% 2.5%;
  width: 100%;
  padding-bottom: 1%;
  /* background-color: rgb(245, 245, 245); */
  border-bottom: 1px solid ${greenSp};
  > div {
    width: 35%;
    justify-content: space-evenly;
    margin-bottom: 2%;
    > h3 {
      color: ${neutralBlueGray};
      font-size: 1.2vw;
    }
    > p {
      color: ${neutralBlueGray};
      font-size: 1.2vw;
      padding: 1% 0;
    }
    > input {
      border-radius: 5px;
      width: 80%;
      border-style: none;
      border: 1px solid ${neutralBlue};
      padding: 1% 0;
    }
    > select {
      border-radius: 5px;
      border-style: none;
      width: 80%;
      padding: 1% 0;
      border: 1px solid ${neutralBlue};
    }
  }
`;
